angular.module('manufacturing')
    .factory('ManufacturingNode', function ($resource) {
        return $resource('/crm/api/manufacturing-node/:id', {}, {
            list: {method: 'GET', isArray: false},
            get: {method: 'GET'},
            update: {method: 'PUT', params: {id: "@id"}},
            remove: {method: 'DELETE'},
            autocomplete: {method: 'GET', isArray: true, url: '/crm/api/manufacturing-node/autocomplete'}
        })
    })
    .component('manufacturingNodePicker', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            required: "=?",
            modelType: '<?',
            activeOnly: "<?",
            locationId: "<?",
            userOnly: "<?",
            onChange: '&?',
        },
        template: `
            <ol class="nya-bs-select btn-sm" ng-click="$ctrl.refreshData()" ng-model="$ctrl.selected" ng-change="$ctrl.onSelectionChanged()" actions-box="true" data-selected-text-format="count>2" multiple size="10" title="-- węzeł --" live-search="true" ng-model-options="{ updateOn: 'blur' }">
                <li nya-bs-option="option in $ctrl.items track by option.id" data-value="option" deep-watch="true">
                    <a>
                        <span>{{option.name}} <span ng-if="option.active === false" title="Nieaktywny" class="bold text-danger">&nbsp;N&nbsp;</span></span>
                        <span class="check-mark"><i class="fa fa-thumb-tack"></i></span>
                    </a>
                </li>
            </ol>
        `,
        controller: function(ManufacturingNode) {
            const ctrl = this;

            ctrl.$onChanges = changes => {
                if (changes.locationId) {
                    ctrl.items = []
                    if(changes.locationId.currentValue == null){
                        ctrl.selected = null;
                    }
                    ctrl.refreshData()
                }
            }

            ctrl.$onInit = () => {
                ctrl.modelType = ctrl.modelType || "object";
                ctrl.required = ctrl.required || false;
                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => ctrl.modelType === "id" ? viewValue.id : viewValue);
            };

            ctrl.refreshData = search => {
                return ManufacturingNode.autocomplete({search: search, size: 1000, activeOnly: ctrl.activeOnly, locationId: ctrl.locationId, userOnly: ctrl.userOnly}).$promise
                    .then(items => {
                        ctrl.items = formatAndMap(items);
                        return ctrl.items;
                    })
            }

            ctrl.onSelectionChanged = () => {
                ctrl.ngModelCtrl.$setViewValue(ctrl.selected);
                ctrl.ngModelCtrl.$validate();
                if (angular.isFunction(ctrl.onChange)) {
                    ctrl.onChange({$item: ctrl.selected});
                }
            };

            function formatAndMap(items) {
                if (!angular.isArray(items)) {
                    return []
                }
                return items
                    .map(item => ({id: item.id, name: item.name, active: item.active}))
                    .sort((a, b) => a.name > b.name ? 1 : -1)
            }
        }
    })
    .service('ManufacturingNodeService', function ($rootScope, toastr, modals, ManufacturingNode) {
        this.edit = id => {
            return ManufacturingNode.get({id: id}, entity => editModal(entity))
        }
        this.addModal = () => {
            let entity = {
                id: null
            }
            return editModal(entity)
        }
        this.remove = item => {
            return modals.confirmDelete(item.name, () => ManufacturingNode.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast('manufacturing-node.updated')))
        }

        function editModal(entity) {
            return modals.open('app/manufacturing/node/edit-modal.html', 'ManufacturingNodeDialogController', entity, {size: "sm"}, "$ctrl")
        }
    })
    .controller('ManufacturingNodeDialogController', function ($scope, $rootScope, $uibModalInstance, data, toastr, ManufacturingNode) {
        this.$onInit = () => {
            this.item = data;
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = ManufacturingNode.update(this.item).$promise
            } else {
                promise = ManufacturingNode.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast('manufacturing-node.updated')
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
    })
    .component('manufacturingNodeList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/manufacturing/node/list.html',
        controller: function ($scope, $state, $httpParamSerializer, $stateParams, Principal, ManufacturingNodeService) {
            this.reset = () => this.filters = {}
            this.ManufacturingNodeService = ManufacturingNodeService

            this.$onInit = () => {
                this.canEdit = Principal.hasAnyAuthority(['ROLE_MANUFACTURING_ORDER_MANAGEMENT'])
            }

            $scope.$on('manufacturing-node.updated', () => $state.reload())
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('manufacturingNodeList', {
            parent: 'app',
            url: '/manufacturing-node?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_MANUFACTURING_ORDER_MANAGEMENT']
            },
            views: {
                'content@': 'manufacturingNodeList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (ManufacturingNode, $stateParams) => ManufacturingNode.list(angular.copy($stateParams)).$promise
            }
        })
    })
